(function () {
    'use strict';
    /*
     * Copyright (c) 2014 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .service('TagsSvc', TagsSvc);

    TagsSvc.$inject = ['RestResources', 'IhhArrays', '$q'];

    /**
     * This AngularJS service provides cached access to therapy tags from the server.
     * The tags are lazily initialized as needed.
     * @ngdoc service
     * @name TagsSvc
     * @memberOf ihh-rest-api
     */
    function TagsSvc(RestResources, IhhArrays, $q) {
        var tagsResource = RestResources.getTagsResource();
        var me = this;

        var tagLists = {};

        /**
         * Gets a tags array by name.
         * @ngdoc method
         * @memberOf ihh-rest-api.TagsSvc
         * @name getTags
         * @param {String} name the name of the tags array to get
         * @returns {Object} the tags array (or a promise that will resolve to it
         */
        this.getTags = function(name) {
            if (!tagLists[name]) {
                tagLists[name] = [];
                me.refresh(name);
            }

            return tagLists[name];
        };

        /**
         * Refreshes the named tags array from the server.
         * @ngdoc method
         * @memberOf ihh-rest-api.TagsSvc
         * @name refresh
         * @param {String} name the name of the tags array to refresh
         */
        this.refresh = function(name) {
            if (name === 'EquipmentPlus') {
                $q.all([tagsResource.query({
                    limit: 0,
                    order: 'value',
                    name: 'Equipment'
                }).$promise, tagsResource.query({
                    limit: 0,
                    order: 'value',
                    name: 'ResistanceItem'
                }).$promise]).then(function(queryResults) {
                    angular.forEach(queryResults, function(queryResult) {
                        angular.forEach(queryResult.items, function(item) {
                            IhhArrays.addWithNoDup(tagLists[name], item);
                        });
                    });
                });
            }
            else {
                tagsResource.query({
                    limit: 0,
                    order: 'value',
                    name: name
                }, function(queryResult) {
                    angular.forEach(queryResult.items, function(item) {
                        IhhArrays.addWithNoDup(tagLists[name], item);
                    });
                });
            }
        };
    }
})();